import Personalizer from 'personalizer';
import NumberFormatter from 'utils/NumberFormatter';
import NumberFormats from 'utils/personalizer/NumberFormats';

export const DASH = '—';
export const EMPTY = '';
export const NR = 'NR';

export const precisionToNumberFormat = (precision) => {
    switch (precision) {
        case 0:
            return NumberFormats.NO_DECIMAL;
        case 1:
            return NumberFormats.PRECISION1;
        default:
            return undefined;
    }
};

const undefHelper = (input, precision, undefVal) => {
    // should only be called from within GolfFormatter

    if (!input && input !== '0' && input !== 0) {
        return undefVal;
    }

    const numberSeparator = Personalizer.getNumberSeparator();
    const numberFormat = precisionToNumberFormat(precision);
    return NumberFormatter(input, numberSeparator, numberFormat);
};

export const undefDash = (input, precision) => {
    return undefHelper(input, precision, DASH);
};

export const undefEmpty = (input, precision) => {
    return undefHelper(input, precision, EMPTY);
};

/**
 * Format golf leaderboard rank
 * @param {string} input
 * @returns
 */
export const undefRank = (input) => {
    if (!input && input !== '0') {
        return NR;
    }
    return input;
};

export const percent = (input) => {
    // use for percentages as fraction of 1 (ex: 0.7 -> 70%)
    if (!input && input != '0' && input != 0) {
        return DASH + '%';
    }

    try {
        return (input * 100).toFixed(0) + '%';
    } catch (e) {
        return DASH + '%';
    }
};

export const percentOfHundred = (input) => {
    // use for percentages out of 100 (ex: 70 -> 70%)
    if (!input && input != '0' && input != 0) {
        return DASH + '%';
    }

    try {
        return input.toFixed(0) + '%';
    } catch (e) {
        return DASH + '%';
    }
};
